import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import * as API from '../../../api/PharmacyNoteConfigsAPI';

export const usePharmacyNoteConfigs = () => {
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingConfig, setEditingConfig] = useState(null);

    const fetchConfigs = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await API.getAll();
            setConfigs(data.configs || []);
        } catch {
            message.error('Failed to load pharmacy note configs');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchConfigs();
    }, [fetchConfigs]);

    const openCreate = () => {
        setEditingConfig(null);
        setModalVisible(true);
    };

    const openEdit = (record) => {
        setEditingConfig(record);
        setModalVisible(true);
    };

    const handleDelete = async (id) => {
        try {
            await API.remove(id);
            message.success('Config deleted');
            fetchConfigs();
        } catch {
            message.error('Failed to delete config');
        }
    };

    const handleModalSuccess = () => {
        setModalVisible(false);
        fetchConfigs();
    };

    const closeModal = useCallback(() => setModalVisible(false), []);

    return {
        configs,
        loading,
        modalVisible,
        editingConfig,
        openCreate,
        openEdit,
        handleDelete,
        handleModalSuccess,
        closeModal,
    };
};
